// extracted by mini-css-extract-plugin
export default {"root":"resetForm_root__zSycg","root__cta-section":"resetForm_root__cta-section__wdPfT"};